<script>
import axios from 'axios'
import { swalResponse, notify } from '@/utils.js'

function getEmpty() {
    return {
        name: '',
        title: '',
        email: '',
        phone: '',
        message: '',
        privacy: false,
    }
}

function formatContactQuery(formData, target) {
    let formated = {
        working_context: 'general',
        full_name: formData.name,
        email: formData.email,
        phone: formData.phone,
        message: formData.message,
    };

    console.log('formatContactQuery', formated, formData, target)

    return formated;
}

export default {
    name: 'ContactForm',

    props: {
        debug: {
            type: Boolean,
            default: false
        }
    },

    data: () => ({
        isProcessing: false,
        formData: getEmpty(),
    }),

    computed: {
        selectedTypeOfInquiry() {
            return [
                this.formData.connectionType,
                this.formData.investorProfile,
                this.formData.investmentInterest,
                this.formData.capitalRange,
                this.formData.investmentTimeframe,
                this.formData.realEstateInterest,
                this.formData.realEstateRelationship,
                this.formData.partnershipArea,
                this.formData.partnershipType,
                this.formData.technologyArea,
                this.formData.beyondOrgType,
                this.formData.professionalDiscipline,
                this.formData.mediaInquiryType,
                this.formData.careerCategory,
                this.formData.opportunityStage,
                this.formData.preferredTiming,
            ].filter(Boolean).join(' / ');
        }
    },

    methods: {
        async submitForm($event) {
            $event.preventDefault();

            this.isProcessing = true;

            try {
                const response = await axios.post(
                    'contacto',
                    formatContactQuery(this.formData, this)
                );

                swalResponse(response)

                if (response && response.status) {
                    this.formData = getEmpty();
                }
            } catch (e) {
                console.error('Error in submitForm:', e);

                notify(
                    'Error submitting form',
                    'error'
                );
            } finally {
                this.isProcessing = false;
            }
        }
    },
};
</script>

<template>

    <form
        id="contact-form"
        class="contact__form"
        action="#"
        @submit.prevent="submitForm"
    >

        <div class="contact__field">

            <label for="name">
                Name
            </label>

            <input
                v-model="formData.name"
                type="text"
                id="name"
                name="name"
                placeholder="Your name"
                required
            >

        </div>

        <div class="contact__field">

            <label for="email">
                Email
            </label>

            <input
                v-model="formData.email"
                type="email"
                id="email"
                name="email"
                placeholder="Your email"
                required
            >

        </div>

        <div class="contact__field">

            <label for="phone">
                Phone
            </label>

            <input
                v-model="formData.phone"
                type="tel"
                id="phone"
                name="phone"
                placeholder="Your phone number"
            >

        </div>

        <div class="contact__field">

            <label for="subject">
                Subject
            </label>

            <select
                id="subject"
                name="subject"
            >
                <option value="">
                    Select an option
                </option>

                <option value="general">
                    General Information
                </option>

                <option value="visit">
                    Plan a Visit
                </option>

                <option value="prayer">
                    Prayer Request
                </option>

                <option value="ministries">
                    Ministries
                </option>

                <option value="other">
                    Other
                </option>
            </select>

        </div>

        <div class="contact__field contact__field--message">

            <label for="message">
                Message
            </label>

            <textarea
                v-model="formData.message"
                id="message"
                name="message"
                placeholder="Tell us how we can help..."
                rows="6"
                required
            ></textarea>

        </div>

        <div class="form__checkbox">

            <input
                v-model="formData.privacy"
                type="checkbox"
                id="privacy"
                required
            >

            <label for="privacy">

                I agree to the

                <a
                    :href="'site_br_pp' | cr"
                    target="_blank"
                >
                    Privacy Policy
                </a>

                and

                <a
                    :href="'site_br_tc' | cr"
                    target="_blank"
                >
                    Terms of Service
                </a>.

            </label>

        </div>

        <button
            type="submit"
            class="contact__button"
            :disabled="isProcessing"
        >
            {{ isProcessing ? 'SENDING...' : 'SEND MESSAGE' }}
        </button>

        <pre v-if="debug">
            {{ formData }}
        </pre>

    </form>

</template>

<style lang="scss" scoped>
.contact__form {
    display: grid;

    grid-template-columns: 1fr;

    gap: 25px;
}

.contact__field {
    display: flex;
    flex-direction: column;

    gap: 9px;

    label {
        font-size: .95rem;
        font-weight: 500;

        letter-spacing: .5px;

        color: var(--text);
    }

    input,
    select,
    textarea {
        width: 100%;

        padding: 13px 0;

        border: none;
        border-bottom: 1px solid #d4d4d4;
        border-radius: 0;

        background: transparent;

        font-family: inherit;

        font-size: .95rem;

        color: var(--text);

        outline: none;

        transition: border-color .3s ease;

        &:focus {
            border-bottom-color: var(--primary);
        }
    }

    input::placeholder,
    textarea::placeholder {
        color: #999;
    }

    select {
        appearance: none;

        cursor: pointer;
    }

    textarea {
        min-height: 120px;

        line-height: 1.6;

        resize: vertical;
    }
}

.form__checkbox {
    display: flex;

    align-items: flex-start;

    gap: 12px;

    margin-top: 5px;

    input {
        width: 18px;
        height: 18px;

        margin-top: 2px;

        accent-color: var(--primary);

        cursor: pointer;
    }

    label {
        font-size: .85rem;

        line-height: 1.6;

        color: #666;
    }

    a {
        color: var(--primary);

        text-decoration: underline;
    }
}

.contact__button {
    align-self: flex-start;

    min-width: 150px;
    min-height: 42px;

    padding: 0 25px;

    border: 1px solid var(--primary);

    background: transparent;

    color: var(--primary);

    font-size: .95rem;
    font-weight: 600;

    letter-spacing: .8px;

    cursor: pointer;

    transition:
        background .3s ease,
        color .3s ease,
        opacity .3s ease;

    &:hover {
        background: var(--primary);

        color: var(--white);
    }

    &:disabled {
        opacity: .6;

        cursor: not-allowed;
    }
}

@media (min-width: 1024px) {
    .contact__form {
        grid-template-columns: 1fr 1fr;

        column-gap: 30px;
        row-gap: 28px;
    }

    .contact__field--message {
        grid-column: 1 / -1;
    }

    .form__checkbox {
        grid-column: 1 / -1;
    }

    .contact__button {
        grid-column: 1 / -1;
    }
}
</style>